/**
 * Accesses the proxied login APIs of the web server.
 */
export default class Auth {
  static async login({ email, password, persist }) {
    const response = await fetch('/auth/login', {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({ email, password, persist }),
    });
    if (response.status !== 200) {
      throw response;
    }
  }

  static async logout() {
    const response = await fetch('/auth/logout', {
      method: 'POST',
    });
    if (response.status !== 200) {
      throw response;
    }
  }

  /**
   * Requests to change the current organization cookie to the specified organization.
   * @param {string} organizationId Organization ID being requested to change to.
   */
  static async changeOrganization(organizationId) {
    const response = await fetch('/changeOrganization', {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({ organizationId }),
    });

    if (response.status !== 200) {
      throw response;
    }
  }
}
